import api from "../../services/api";

// Biblioteca oficial, servida pelo próprio site. Módulo e worker têm a mesma versão.
export const PDFJS_PATH = "/pdfjs/6.4.299/";
let libraryPromise;
export function loadPdfLibrary() {
  if (!libraryPromise) {
    const url = new URL(PDFJS_PATH + "pdf.min.mjs", window.location.origin).href;
    libraryPromise = import(/* webpackIgnore: true */ url).then((library) => {
      library.GlobalWorkerOptions.workerSrc = new URL(
        PDFJS_PATH + "pdf.worker.min.mjs", window.location.origin,
      ).href;
      return library;
    }).catch((error) => { libraryPromise = null; throw error; });
  }
  return libraryPromise;
}
export function isPdfAttachment(file) {
  return String(file.ext || "").toLowerCase() === "pdf" ||
    /\.pdf(?:$|[?#])/i.test(file.nome || file.url || "") ||
    String(file.mime || file.mime_type || "").toLowerCase() === "application/pdf";
}
export async function fetchPdfBytes(fileUrl, fileName, signal) {
  const url = new URL(fileUrl, window.location.origin);
  const response = await api.get("/conteudos/anexo", {
    params: { path: url.pathname + url.search, name: fileName || "arquivo.pdf" },
    responseType: "arraybuffer", signal,
  });
  return new Uint8Array(response.data);
}
